import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user, token, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return null; // or a loading spinner
  }

  if (!token) {
    return <Navigate to="/landing" state={{ from: location, openLogin: true }} replace />;
  }

  if (user) {
    const { kycStatus, bankStatus, additionalDetailsStatus } = user;
    const currentPath = location.pathname;

    // List of registration/status routes that should be accessible during the process
    const registrationRoutes = [
      '/kyc',
      '/additional-details',
      '/bank-details',
      '/account-status',
      '/basic-details'
    ];

    // Status-based redirection logic
    if (kycStatus === 'not submitted') {
      if (currentPath !== '/kyc') {
        return <Navigate to="/kyc" replace />;
      }
    } else if (additionalDetailsStatus === 'not submitted') {
      if (currentPath !== '/additional-details') {
        return <Navigate to="/additional-details" replace />;
      }
    } else if (bankStatus === 'not submitted') {
      if (currentPath !== '/bank-details') {
        return <Navigate to="/bank-details" replace />;
      }
    } else if (kycStatus === 'pending' || bankStatus === 'pending' || kycStatus === 'progress' || bankStatus === 'progress') {
      if (currentPath !== '/account-status') {
        return <Navigate to="/account-status" replace />;
      }
    } else if (kycStatus === 'approved' && bankStatus === 'approved') {
      // If user is fully approved and tries to access registration/status pages, redirect to home
      if (registrationRoutes.includes(currentPath)) {
        return <Navigate to="/" replace />;
      }
    }
  }

  return children;
};

export default ProtectedRoute;
